import type { User } from '@/server/models'

import type { SerializedRichText } from '@/client/services/richText/types'
import type { AuthDetailsByWorld } from '@/client/services/worlds'

export type UserLike = {
  id?: User['id'] | null
  roles?: User['roles'] | null
  worlds?: AuthDetailsByWorld
  channelIds?: number[]
}

export enum SuspensionActionType {
  Suspend = 'suspend',
  Unsuspend = 'unsuspend',
}

export enum SuspensionActionContext {
  CommunitySuspension = 'community-suspension',
  OnboardingRejection = 'onboarding-rejection',
  SessionRemoval = 'session-removal',
  // TODO: consider refactoring this to AutomaticSuspensionContentFlag, AutomaticSuspensionEscalation, and AutomaticSuspensionLearnerNoShows, since LearnerNoShows is technically an automatic suspension
  AutomaticSuspension = 'automatic-suspension',
  LearnerNoShows = 'learner-no-shows',
  UserAdminPage = 'admin',
  AgeAssuranceFailure = 'age-assurance-failure',
}

export type SuspensionAction = {
  platformFeedbackId: number | null
  context: SuspensionActionContext
  actorUserId: number | null
  action: SuspensionActionType
  note: SerializedRichText | null
  timestamp: string
}

export type ApplicationScreenDetails = {
  version: string
  score: number
  shouldApprove: boolean
  breakdown: Record<string, number>
}

export enum PortfolioShareIntentionsReason {
  College = 'college',
  Organization = 'organization',
  Other = 'other',
  PreferNotToShare = 'prefer-not-to-share',
}

export type PortfolioShareIntentions =
  | {
      reason: PortfolioShareIntentionsReason.College
      partnerColleges: string[] | null
      otherColleges: string[] | null
      downloadedAt: string | null
    }
  | {
      reason: PortfolioShareIntentionsReason.Organization
      organizationName: string | null
      downloadedAt: string | null
    }
  | {
      reason: PortfolioShareIntentionsReason.Other
      otherExplanation: string | null
      downloadedAt: string | null
    }
  | {
      reason: PortfolioShareIntentionsReason.PreferNotToShare
      downloadedAt: string | null
    }
